/**
 * Emits the event informing the app was booted.
 */
class AppContainer {
  /**
   * @param {AppEvents}    appEvents  To emit the event.
   * @param {CommonEvents} APP_EVENTS To get the event name.
   */
  constructor(appEvents, APP_EVENTS) {
    'ngInject';

    /**
     * A local reference for the `appEvents` service.
     * @type {AppEvents}
     */
    this.appEvents = appEvents;
    /**
     * A local reference for the `APP_EVENTS` constant.
     * @type {CommonEvents}
     */
    this.APP_EVENTS = APP_EVENTS;
  }
  /**
   * After all the elements inside the container are linked, emit the app informing that the app
   * was booted.
   */
  $postLink() {
    this.appEvents.emit(this.APP_EVENTS.start);
  }
}
/**
 * This may look confusing, but let's start with the rule that a component can't be the direct
 * parent of a container. So this container works as a wrapper a parent container will use to
 * inject another container inside this one child component.
 * @ngesdoc component
 * @ngname appContainer
 * @ngcontroller {@link AppContainer}
 * @ngcontainer
 * @ngmodule root
 * @ngtransclude
 */
export default {
  controller: AppContainer,
  template: `
    <app>
      <ng-transclude></ng-transclude>
    </app>
  `,
  transclude: true,
};
